module.exports = __webpack_public_path__ + "static/img/index-3.a516edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/index-3.jpg
// module id = Xgz1
// module chunks = 0